$(document).ready(function () {
    $('#addassignment').on('show.bs.modal', function (e) {
        $('.specialty_select').hide();
        var acyr = $('ul.acyr-filter li.active').text().trim();
        $(this).find('input[type="hidden"][name="acyr"]').val(acyr);
        $('#degreeprogyr').on('change', function () {
            var selected_dpyr = $(this).find(':selected').val();
            if (selected_dpyr == 4) {
                $('.specialty_select').fadeIn();
            } else {
                $('.specialty_select').fadeOut();
            }
        });
    });

    $('[id^="editassignment"]').on('show.bs.modal', function (e) {
        var buttonId = e.target.id;
        var assignmentId = buttonId.substring(14);
        $('.specialty_select').hide();
        $('#deadline_' + assignmentId).val($('input[type="hidden"][name="assignment_deadline_' + assignmentId + '"]').val());
        var selected_dpyr = $(this).find(':selected').val();
        if (selected_dpyr == 4) {
            $('.specialty_select').fadeIn();
        } else {
            $('.specialty_select').fadeOut();
        }
    });
});
